import { gsap } from "gsap";
import { Container, Graphics, Sprite, Texture } from "pixi.js";

import { AbstractBitmapText } from "../graphics/AbstractBitmapText";
import { AbstractSpine } from "../graphics/AbstractSpine";
import { ShakeRepeat } from "../types/enums";
import { ShakeProps } from "../types/interfaces";

export const generateScaledSprite = (textureName: string): Sprite => {
    const texture = Texture.from(textureName);

    const sprite = new Sprite(texture);
    sprite.name = textureName;
    sprite.scale.set(0.5);

    return sprite;
};

export const fitDisplayObjectToWidth = (
    displayObject: Sprite | AbstractSpine | Graphics | Container | AbstractBitmapText,
    maxWidth: number
): void => {
    if (displayObject.width > maxWidth) {
        displayObject.width = maxWidth;
        displayObject.scale.y = displayObject.scale.x;
    }
};

export const shake = (
    shakeProps: ShakeProps = {
        displayObject: new Container(),
        intensity: 0,
        defaultX: -5000,
        defaultY: -5000,
        duration: 0.2,
        repeat: ShakeRepeat.FIVE,
    }
): void => {
    const initialX =
        shakeProps.defaultX === -5000 ? shakeProps.displayObject!.x : shakeProps.defaultX;
    const initialY =
        shakeProps.defaultY === -5000 ? shakeProps.displayObject!.y : shakeProps.defaultY;

    gsap.fromTo(
        shakeProps.displayObject!,
        {
            x: initialX,
            y: initialY,
        },
        {
            x: `+=${shakeProps.intensity / 2}`,
            y: `+=${shakeProps.intensity}`,
            duration: shakeProps.duration! / 4,
            repeat: shakeProps.repeat,
            yoyo: true,
            ease: `power1.inOut`,
            onStart: function () {
                gsap.fromTo(
                    shakeProps.displayObject!,
                    {
                        x: initialX,
                        y: initialY,
                    },
                    {
                        x: `-=${shakeProps.intensity}`,
                        y: `-=${shakeProps.intensity * 2}`,
                        duration: shakeProps.duration! / 4,
                        repeat: 3,
                        yoyo: true,
                        ease: `power1.inOut`,
                    }
                );
            },
            onComplete: function () {
                shakeProps.displayObject!.x = initialX!;
                shakeProps.displayObject!.y = initialY!;
            },
        }
    );
};
